/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExchange} from '@fortawesome/pro-duotone-svg-icons';

const SubstitutionsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faExchange} {...props} />
);

export default SubstitutionsIcon;
